import { render, staticRenderFns } from "./SettingsRecipesModal.vue?vue&type=template&id=0368082c&scoped=true&lang=pug"
import script from "./SettingsRecipesModal.vue?vue&type=script&lang=js"
export * from "./SettingsRecipesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0368082c",
  null
  
)

export default component.exports